import { clsx } from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NAV_ICON_PAIRS, type NavIconName } from './navFaIcons';

type NavIconProps = {
  name: NavIconName;
  filled?: boolean;
  className?: string;
};

export function NavIcon({ name, filled = false, className }: NavIconProps) {
  const pair = NAV_ICON_PAIRS[name];
  return (
    <FontAwesomeIcon
      icon={filled ? pair.filled : pair.outline}
      className={clsx('shrink-0', className)}
      aria-hidden
    />
  );
}

export type { NavIconName };
